import type { ReactNode } from 'react';

/**
 * The bar across the top of a chat that lives in a side panel.
 *
 * Owns the chrome only — height, padding, and the title's type and truncation — so every panel
 * reads as the same surface. Which actions sit on the right is the host's business: the chat panel
 * offers visibility, new, expand, history and close; the workflow builder offers history and close
 * beside its version badge.
 */
export const PanelHeader = ({
  title,
  badge,
  trailing,
}: {
  title: string;
  /** Sits immediately after the title, for a panel whose thread is scoped to something. */
  badge?: ReactNode;
  trailing?: ReactNode;
}) => (
  <div className="flex h-11 shrink-0 items-center justify-between gap-sm px-xl">
    <div className="flex min-w-0 items-center gap-md">
      {/* The design's Text sm/Medium is 14px/600; the app's `txt-small-*` scale is 13px/500. */}
      <p className="min-w-0 truncate font-mulish text-[14px] font-semibold leading-5 tracking-[-2%] text-text-primary">
        {title}
      </p>
      {badge}
    </div>
    {trailing ? (
      <div className="flex shrink-0 items-center gap-xs">{trailing}</div>
    ) : null}
  </div>
);
